import React from "react";

function Login() {
  return (
    <div className="loginContainer">
      <button className="loginBtn">login</button>
      <button className="registerBtn">register</button>
    </div>
  );
}

export default Login;
